import HtmlToText from 'html-to-text';

export default function htmlToText(html) {
  if (!html) {
    return '';
  }
  const divRe = /<\/div>/g;
  // add new lines between divs so that plaintext is correctly formatted
  html = html.replace(divRe, '</div></br>');
  return HtmlToText.fromString(html, { unorderedListItemPrefix: ' ', wordwrap: false });
}



// WEBPACK FOOTER //
// ./src/scripts/domain/models/conversation_item/html_to_text.js